var escape = require("../../../../../../../../css-loader/lib/url/escape.js");
exports = module.exports = require("../../../../../../../../css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".titleLine_1PkSkm4K {\n  width: 100%;\n  height: 0.8rem;\n  line-height: 0.8rem;\n  position: absolute;\n  top: 0;\n  left: 0;\n  text-align: center;\n  color: #fff;\n  font-size: 0.373333rem;\n  font-weight: bold;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  background-image: url(" + escape(require("./zz.png")) + ");\n  background-repeat: repeat-x;\n  background-size: 100% 0.8rem;\n  -webkit-transition: all 0.5s;\n  transition: all 0.5s;\n}\n\n.titleLineHide_T9_U-GHI {\n  top: -0.666667rem;\n}", ""]);

// exports
exports.locals = {
	"titleLine": "titleLine_1PkSkm4K",
	"titleLineHide": "titleLineHide_T9_U-GHI"
};